module.exports = __webpack_public_path__ + "img/9788979199727.aef15895.jpg";